import { forwardRef } from 'react'
import styled from 'styled-components'
import { Label } from '@/components/text'

const Wrapper = styled.div`
  text-align: center;
  user-select: none;
  z-index: 1;
  padding: calc(20px + env(safe-area-inset-top)) 16px 8px;
  flex-shrink: 0;

  position: relative;
  border-bottom: 1px solid #e6e6e6;
  &[aria-hidden='true'] {
    display: none;
  }
`

const InnerFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 4px 8px 12px;
`

const ButtonContainer = styled.div`
  position: relative;
  height: 24px;
  width: 24px;
`

const Outer: React.FC<{ isSheet?: boolean; children?: React.ReactNode }> = ({
  isSheet,
  children,
  ...rest
}) => (isSheet ? <>{children}</> : <Wrapper {...rest}>{children}</Wrapper>)

type ModalHeaderProps = {
  buttons?: React.ReactNode
  children?: React.ReactNode
  isSheet?: boolean
}

const ModalHeader = forwardRef<HTMLDivElement, ModalHeaderProps>(
  ({ buttons, children, isSheet, ...rest }, ref) => {
    return (
      <Outer isSheet={isSheet} {...rest}>
        <InnerFlex>
          <Label type="large">
            <div ref={ref}>{children}</div>
          </Label>
          <ButtonContainer>{buttons}</ButtonContainer>
        </InnerFlex>
      </Outer>
    )
  }
)

export default ModalHeader
